<template>
  <div>
    <div class="calendar-box bg-white">
      <div class="flex justify-space-between bg-gray-100">
        <div class="flex date-picker-box">
          <v-btn outlined color="grey" class="bg-white" @click="addDate(0, -1)" :disabled="isLoading">
            <v-icon>mdi-chevron-double-left</v-icon>
          </v-btn>
          <v-btn outlined color="grey" class="bg-white" @click="addDate(-1)" :disabled="isLoading">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <div class="date-picker">
            <v-menu v-model="menuDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y
              :disabled="isLoading">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field class="bg-white" :value="$helper.datelabel(datePicker)" :disabled="isLoading" outlined
                  hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="datePicker" no-title locale="th" @input="addDate(); menuDatePicker = false;"
                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
            </v-menu>
          </div>
          <v-btn outlined color="grey" class="bg-white" @click="addDate(1)" :disabled="isLoading">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn outlined color="grey" class="bg-white" @click="addDate(0, 1)" :disabled="isLoading">
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-btn>
          <v-btn outlined color="grey" class="bg-white text--darken-2"
            @click="addDate(0, 0, $moment().format('YYYY-MM-DD'))" :disabled="isLoading">Today</v-btn>
        </div>
        <div class="flex align-center justify-end mr-3 text-gray-400">{{ $t('data') }} {{ $moment(config.startDate,
          "YYYY-MM-DD").format('DD MMM YYYY') }} - {{ $moment(config.startDate, "YYYY-MM-DD").add(config.days,
    "days").format('DD MMM YYYY') }}</div>
      </div>
      <DayPilotScheduler v-show="!isLoading && areas && areas.length" id="dp" :config="config" ref="scheduler"
        class="calendar-daypilot" />
      <div v-if="!isLoading && (!areas || areas.length == 0)" class="no-data">{{ $t('area.no_market_area') }}</div>
      <div v-if="isLoading" class="flex align-center justify-center fill-height">
        <v-progress-circular color="green" size="70" indeterminate></v-progress-circular>
      </div>
    </div>
    <ContractDetailDialog :areaObject="currentArea" v-model="areaDialog" :show-area="false"
      @reloadContract="reloadContract" :projectId="projectId" :marketId="marketId" :contractId="contractId"
      :startDateReq="startDateTemp" :endDateReq="endDateTemp" />
  </div>
</template>

<script>
import { DayPilot, DayPilotScheduler } from "daypilot-pro-vue";
import ContractDetailDialog from "./ContractDetailDialog";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "Scheduler",
  components: {
    DayPilotScheduler,
    ContractDetailDialog
  },
  computed: {
    ...mapGetters({
      areas: "markets/getAreas",
      getMarketName: "markets/getMarketName",
      areaBookings: "areaBooking/getAreaBookings"
    }),
    scheduler: function () {
      return this.$refs.scheduler.control;
    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      isShowMonthly: false,
      isShowDaily: false,
      areaDialog: false,
      contractId: "",
      currentArea: null,
      config: {
        height: 100,
        timeHeaders: [{ groupBy: "Month" }, { groupBy: "Day", format: "d" }],
        scale: "Day",
        days: DayPilot.Date.today().daysInYear(),
        startDate: DayPilot.Date.today().firstDayOfYear(),
        separators: [
          { color: "#FF000050", location: new DayPilot.Date(), width: 5 }
        ],
        cellWidthSpec: "Fixed",
        cellWidth: 100,
        eventHeight: 35,
        rowHeaderColumns: [],
        timeRangeSelectedHandling: "Enabled",
        onTimeRangeSelected: this.timeRangeSelected,
        eventMoveHandling: "Disabled",
        // onEventMoved
        eventResizeHandling: "Disabled",
        // onEventResized
        eventDeleteHandling: "Disabled",
        // onEventDeleted
        onBeforeCellRender: this.beforeCellRender,
        onBeforeTimeHeaderRender: this.beforeTimeHeaderRender,
        onBeforeRowHeaderRender: this.beforeRowHeaderRender,
        onBeforeRowHeaderColumnRender: this.beforeRowHeaderColumnRender,
        eventClickHandling: "Enabled",
        onEventClicked: this.eventClicked,
        onResourceHeaderClick: this.headerClicked,
        treeEnabled: true,
        events: [],
        resources: []
      },
      menuDatePicker: false,
      datePicker: this.$moment().format("YYYY-MM-DD"),
      startDateTemp: null,
      endDateTemp: null
    };
  },
  created() {
    this.config.rowHeaderColumns = [
      { text: this.$t('area.area_name'), display: "name" },
      { text: this.$t('status'), display: "currentStatus" }
    ];
  },
  async mounted() {
    this.initStyle();
    await this.initData();
    this.onSelectDate(this.datePicker);
    // this.scheduler.message("Loaded!");
  },
  watch: {
    areas: {
      async handler() {
        if (this.areas && this.areas.length) {
          await this.initData();
          this.onSelectDate(this.datePicker);
        }
      },
      deep: true
    },
    areaDialog() {
      if (!this.areaDialog) {
        this.startDateTemp = null;
        this.endDateTemp = null;
      }
    }
  },
  methods: {
    ...mapMutations({
      setCurrentArea: "area/setCurrentArea"
    }),
    initStyle() {
      let height = screen.height;
      if (height && height > 100) {
        height = height - 520;
      } else {
        height = 400;
      }
      this.config.height = height;
    },
    async initData() {
      this.isLoading = true;
      if (this.areas && this.areas.length) {
        this.config.startDate = this.$moment(this.datePicker, "YYYY-MM-DD")
          .add(-1, "months")
          .format("YYYY-MM-DD");
        this.loadResources(this.areas);
        await this.getAreaBookings();
        this.loadEventsContract(this.areas, this.areaBookings);
        this.scheduler.update({
          startDate: this.config.startDate,
          resources: this.config.resources,
          events: this.config.events
        });
      }
      this.isLoading = false;
    },
    async getAreaBookings() {
      let startDate = this.$moment(this.config.startDate, "YYYY-MM-DD");
      let endDate = this.$moment(startDate).add(this.config.days, "days");
      try {
        await this.$store.dispatch("areaBooking/getAreaBookingBetweenDate", {
          marketId: this.marketId,
          startDate: startDate.toDate(),
          endDate: endDate.toDate()
        });
      } catch (error) {
        if (error.response && error.response.data)
          this.$toast.show({
            content: `${this.$t('error')} : ${error.response.data.code} ${error.response.data.error}`,
            color: "error"
          });
        else
          this.$toast.show({
            content: `${this.$t('error')} : ${error.message}`,
            color: "error"
          });
      }
    },
    loadResources(areas) {
      if (areas && areas.length) {
        this.config.resources = [
          {
            name: this.$t('area.renting_rate'),
            id: "chart",
            frozen: "top",
            cellsAutoUpdated: true,
            cellsDisabled: true,
            columns: false,
            cssClass: "scheduler_default_rowheader"
          }
        ];
        for (let area of areas) {
          if (this.isShowMonthly || this.isShowDaily) {
            area.children = [];
            if (this.isShowMonthly)
              area.children.push({
                name: this.$t('monthly'),
                id: `monthly-${area.id}`
              });
            if (this.isShowDaily)
              area.children.push({
                name: this.$t('daily'),
                id: `daily-${area.id}`
              });
          }
          area.cellsDisabled = false;
          area.area = area;
          this.config.resources.push(area);
        }
      }
    },
    loadEventsContract(areas = [], areaBookings = []) {
      let events = [];
      let i = 0;
      for (const area of areas) {
        let contract = area.contract;
        let areaBooked = area.areaBooking;
        if (contract) {
          events.push({
            // id: contract.objectId,
            id: i,
            area,
            contract,
            start: contract.startDate.iso,
            end: contract.endDate.iso,
            text: `${area.statusText} (${contract.contractId})`,
            resource: `${area.id}`,
            barColor: `${area.statusColorBar}`,
            barBackColor: `${area.statusColorBar}90`
          });
          i++;
        }
        if (areaBooked) {
          events.push({
            // id: contract.objectId,
            id: i,
            area,
            areaBooked,
            start: this.thaiTimeZone(areaBooked.startDate.iso),
            end: this.thaiTimeZone(areaBooked.endDate.iso),
            text: `${this.$t('daily')} (${areaBooked.booking.documentId})`,
            resource: `${area.id}`,
            barColor: `${"#029ce5"}`,
            barBackColor: `${"#029ce5"}90`
          });
          i++;
        }
      }
      for (const areaBooking of areaBookings) {
        if (areaBooking && !areaBooking.checkedInDate) {
          events.push({
            // id: contract.objectId,
            id: i,
            area: areaBooking.area,
            areaBooking,
            start: this.thaiTimeZone(areaBooking.startDate.iso),
            end: this.thaiTimeZone(areaBooking.endDate.iso),
            text: `${this.$t('booked')}${areaBooking.booking.type == "daily" ? this.$t('daily') : this.$t('monthly')
              } (${areaBooking.booking.documentId})`,
            resource: `${areaBooking.area.objectId}`,
            barColor: `${"#f9a825"}`,
            barBackColor: `${"#f9a825"}90`
          });
          i++;
        }
      }
      this.config.events = events;
    },
    eventClicked(args) {
      this.currentArea = args.e.data.area;
      this.setCurrentArea(args.e.data.area)
      this.contractId =
        this.currentArea && this.currentArea.contract
          ? this.currentArea.contract.objectId
          : null;
      this.areaDialog = true;
    },
    headerClicked(args) {
      if (
        args &&
        args.row &&
        args.row.data &&
        (args.row.data.contract || args.row.data.areaBooking)
      ) {
        if (args.row.data.contract)
          this.scheduler.scrollTo(args.row.data.contract.startDate.iso);
        else if (args.row.data.areaBooking)
          this.scheduler.scrollTo(args.row.data.areaBooking.startDate.iso);
      }
    },
    async timeRangeSelected(args) {
      let area = this.findArea(args.resource);
      if (area) {
        this.currentArea = area;
        this.contractId =
          this.currentArea && this.currentArea.contract
            ? this.currentArea.contract.objectId
            : null;

        this.startDateTemp = this.$moment(args.start.value).toDate();
        this.endDateTemp = this.$moment(args.end.value)
          .add(-1, "milliseconds")
          .toDate();
        this.areaDialog = true;
      }
    },
    beforeCellRender(args) {
      const scheduler = this.scheduler;
      const resources = scheduler.rows
        .all()
        .filter(r => r.data.frozen !== "top" && !r.children().length);
      const max = resources.length;
      const events = scheduler.events.forRange(args.cell.start, args.cell.end)
        .length;
      const utilization = events / max;
      if (args.cell.resource === "chart") {
        const percentageNum = 100 * utilization;
        args.cell.properties.backColor = "#ffffff";
        args.cell.properties.areas = [];
        if (events > 0) {
          const maxHeight = scheduler.eventHeight || 30;
          const percentage = Math.min(utilization, 1);
          const height = percentage * maxHeight;
          args.cell.properties.areas = [
            {
              bottom: 1,
              height: height,
              left: 0,
              right: 2,
              backColor: "#f6b26b",
              style:
                "box-sizing: border-box; border: 1px solid #e69138; opacity: " +
                percentage
            }
          ];
        }
        args.cell.properties.areas.push({
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          style: "display: flex; justify-content: center; align-items: center;",
          text: `${percentageNum.toFixed(0)}%`
        });
      }
    },
    beforeTimeHeaderRender(args) {
      if (args.header.level == 0) {
        args.header.text = this.$moment(args.header.start.value).format(
          "MMMM YYYY"
        );
        args.header.toolTip = this.$moment(args.header.start.value).format(
          "MMMM YYYY"
        );
      }
    },
    beforeRowHeaderRender(args) {
      if (
        args.row.columns &&
        args.row.columns.length > 0 &&
        args.row.columns[0]
      ) {
        args.row.columns[0].areas = [];
        if (args.row.columns[0].text) {
          for (const text of args.row.data.currentStatus) {
            args.row.columns[0].areas.push({
              // top: 0,
              // left: 0,
              // bottom: 0,
              // right: 0,
              // icon: "fas fa-user",
              // width: 30,
              // height: 30,
              // fontColor: this.colorByText(text),
              // backColor: "#FFF"
            });
          }
        }
      }
      if (
        args.row.columns &&
        args.row.columns.length > 0 &&
        args.row.columns[1]
      ) {
        args.row.columns[1].areas = [];
        if (args.row.columns[1].text && args.row.columns[1].text.length) {
          let number = args.row.columns[1].text.length;
          let i = 0;
          let width = this.scheduler.cellWidth;
          for (const text of args.row.columns[1].text) {
            args.row.columns[1].areas.push({
              top: 0,
              left: i * (width / number),
              width: width / number,
              height: 4,
              icon: "fas fa-user",
              backColor: this.colorByText(text)
            });
            i++;
          }
        }
      }
    },
    beforeRowHeaderColumnRender(args) {
      args.column.cssClass = "scheduler_default_columnheader_cell";
    },
    reloadContract(booking) {
      // if (
      //   booking &&
      //   booking.areaBookings &&
      //   booking.areaBookings.length &&
      //   booking.areaBookings[0].area &&
      //   this.currentArea.objectId == booking.areaBookings[0].area.objectId
      // ) {
      //   this.currentArea = booking.areaBookings[0].area;
      //   if (booking.areaBookings[0].area.contract)
      //     this.contractId = booking.areaBookings[0].area.contract.objectId;
      // }
      // this.initData();
      this.$emit("reloadContract");
    },
    async addDate(days = 0, months = 0, datePicker = this.datePicker) {
      this.datePicker = this.$moment(datePicker, "YYYY-MM-DD")
        .add(days, "days")
        .add(months, "months")
        .format("YYYY-MM-DD");
      await this.initData();
      this.onSelectDate(this.datePicker);
    },
    onSelectDate(event) {
      this.scheduler.scrollTo(new DayPilot.Date(event));
    },
    colorByText(text = "") {
      let color = "#eeeeee";
      if (text == this.$t('bill.bad_debt')) {
        color = "#3e3e45";
      } else if (text == this.$t('suspend.suspend_sale') || text == this.$t('booked')) {
        color = "#f9a825";
      } else if (text == this.$t('invoice.no_pending_invoice')) {
        color = "#4CAF50";
      } else if (text == this.$t('payment.pending')) {
        color = "#F44336";
      } else if (text == this.$t('daily')) {
        color = "#029ce5";
      } else {
        color = "#eeeeee";
      }
      return color;
    },
    findArea(areaId) {
      let area;
      if (areaId && this.areas && this.areas.length) {
        area = this.areas.find(ar => ar.objectId == areaId);
      }
      return area;
    },
    thaiTimeZone(dateTime, addTime = 7) {
      let res = "";
      if (dateTime) {
        res = this.$moment(dateTime)
          .add(addTime, "hours")
          .format();
      }
      return res;
    }
  }
};
</script>

<style lang="css">
.scheduler_default_columnheader_cell .scheduler_default_columnheader_cell_inner {
  justify-content: center;
}

.scheduler_default_rowheader .scheduler_default_rowheader_inner {
  justify-content: center;
}
</style>
<style lang="scss" scoped>
.calendar-box {
  border: 1px solid #e4e4e4;
  border-radius: 5px;
  position: relative;
  height: calc(100vh - 320px);

  .no-data {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    font-weight: bold;
    color: rgba(128, 128, 128, 0.726);
  }

  .date-picker-box {
    // border: 1px solid #e4e4e4;
    // border-radius: 5px;
    padding: 10px;

    // margin-bottom: 5px;
    div.date-picker {
      max-width: 170px;
      margin: 0 2px;
    }

    button {
      margin: 0 2px;
      min-width: unset;
      padding: 0 7px;
    }
  }

  .date-picker-box::v-deep .v-input__slot {
    min-height: 36px;
    background: #fff;
  }
}
</style>
